<template>
  <!--
      作者：luoyiming
      时间：2019-10-24
      描述：支付宝推广人列表
  -->
  <div class="product-list">
    <!--搜索表单-->
    <!-- <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
      >
        
        <el-form-item label="商品名称"
          ><el-input
            size="small"
            v-model="searchForm.product_name"
            placeholder="请输入商品名称"
          ></el-input
        ></el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div> -->
    <!--添加产品-->
    <div class="common-level-rail">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="addClick"
        >添加推广人</el-button
      >
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column prop="id" label="id"></el-table-column>
          <el-table-column
            prop="user_id"
            label="推广人用户id"
          ></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="complete" label="成交金额"></el-table-column>
          <el-table-column label="url">
            <template slot-scope="scope">
              https://shoujizulin2.rchz.top/index2.html?id={{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column label="二维码">
            <template slot-scope="scope">
              <el-button
                @click="getProQrcode(scope.row)"
                type="primary"
                size="small"
                >获取二维码</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="beizhu" label="备注"></el-table-column>
          <el-table-column
            prop="create_time"
            label="发布时间"
          ></el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <div class="table-btn-column">
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑推广人</el-button
                >
                <el-button @click="delClick(scope.row)" type="text" size="small"
                  >删除推广人</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- dialog -->
    <div>
      <!-- 添加推广人 -->
      <el-dialog
        title="添加推广人"
        :visible.sync="showAdddialog"
        class="dialogBox"
      >
        <el-form :model="addUserData" label-width="100px">
          <el-form-item label="推广人名称">
            <el-input
              v-model="addUserData.name"
              placeholder="请填写推广人名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="推广人用户id">
            <el-input
              v-model="addUserData.user_id"
              placeholder="请填写推广人用户id"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="addUserData.beizhu"
              placeholder="请填写备注"
            ></el-input>
          </el-form-item>
          <el-form-item label="推广链接">
            <el-input
              v-model="addUserData.url"
              placeholder="请填写推广链接"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showAdddialog = false">取 消</el-button>
          <el-button type="primary" @click="submitAddUser">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑推广人 -->
      <el-dialog
        title="编辑推广人"
        :visible.sync="showEditdialog"
        class="dialogBox"
      >
        <el-form :model="editUserData" label-width="100px">
          <el-form-item label="推广人名称">
            <el-input
              v-model="editUserData.name"
              placeholder="请填写推广人名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="推广人用户id">
            <el-input
              v-model="editUserData.user_id"
              placeholder="请填写推广人用户id"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="editUserData.beizhu"
              placeholder="请填写备注"
            ></el-input>
          </el-form-item>
          <el-form-item label="推广链接">
            <el-input
              v-model="editUserData.url"
              placeholder="请填写推广链接"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showEditdialog = false">取 消</el-button>
          <el-button type="primary" @click="submitEditUser">确 定</el-button>
        </span>
      </el-dialog>
      <!-- e二维码 -->
      <el-dialog title="二维码" :visible.sync="QrcodeDialog" width="30%">
        <div style="display:flex;justify-content: center;align-items: center;">
            <img :src="'https://'+qrcode">
          </div>
      </el-dialog>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, prev, pager, next, jumper,sizes"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import PromotionApi from "@/api/promotion.js";
export default {
  components: {},
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        product_name: "",
        category_id: "",
      },
      /*列表数据*/
      tableData: [],
      //   控制添加推广人展示
      showAdddialog: false,
      addUserData: {
        display_Port:1
      },
      //   编辑推广人展示
      showEditdialog: false,
      editUserData: {},
      //  二维码弹窗
      QrcodeDialog: false,
      qrcode: "",
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*打开添加*/
    addClick() {
      this.showAdddialog = true;
    },
    // 提交添加推广人
    submitAddUser() {
      let self = this;
      let Params = self.addUserData;
      PromotionApi.addProuserList(Params, true)
        .then((data) => {
          self.$message({
            message: "添加成功",
            type: "success",
          });
          self.getData();
        })
        .catch((err) => {
          console.log(err, "=--err");
        });

      self.showAdddialog = false;
    },
    // 获取二维码
    getProQrcode(row) {
      let url = "https://shoujiuzlin2.rchz.top/index2.html?id=" + row.id;
      PromotionApi.getQrcodeUel(
        {
          url: url,
        },
        true
      )
        .then((data) => {
          this.qrcode = data.data.qrcode;
        })
        .catch((err) => {
          console.log(err, "=--err");
        });
      this.QrcodeDialog = true;
    },
    // 打开编辑
    editClick(row) {
      this.id = row.id;
      this.editUserData = {};
      this.showEditdialog = true;
    },
    // 提交编辑推广人
    submitEditUser() {
      let self = this;
      let Params = self.editUserData;
      Params.id = self.id;
      Params.display_Port = 1
      PromotionApi.editProuserList(Params, true)
        .then((data) => {
          self.$message({
            message: "编辑成功",
            type: "success",
          });
          self.getData();
        })
        .catch((err) => {
          console.log(err, "=--err");
        });

      self.showEditdialog = false;
    },
    delClick(row) {
      let self = this;
      self
        .$confirm("删除后将移动到回收站，确定删除该记录吗?", "提示", {
          type: "warning",
        })
        .then(() => {
          PromotionApi.delProuserList({
            id: row.id,
            display_Port:1
          }).then((data) => {
            self.$message({
              message: "删除成功",
              type: "success",
            });
            self.getData();
          });
        });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.display_Port = 1
      self.loading = true;
      PromotionApi.getProuserList(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.product_count = data.data.product_count;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.dialogBox {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/promotion/promotion/zfbvip.vue